export const days = [
    {
        id: 0,
        value: "-"
    },
    {
        id: 1,
        value: 1
    },
    {
        id: 2,
        value: 2
    },
    {
        id: 3,
        value: 3
    },
    {
        id: 4,
        value: 4
    },
    {
        id: 5,
        value: 5
    },
    {
        id: 6,
        value: 6
    },
    {
        id: 7,
        value: 7
    },
    {
        id: 8,
        value: 8
    },
    {
        id: 9,
        value: 9
    },
    {
        id: 10,
        value: 10
    },
    {
        id: 11,
        value: 11
    },
    {
        id: 12,
        value: 12
    }, {
        id: 13,
        value: 14
    },

    {
        id: 15,
        value: 15
    },
    {
        id: 16,
        value: 16
    },
    {
        id: 17,
        value: 17
    }, {
        id: 18,
        value: 18
    }, {
        id: 19,
        value: 19
    }, {
        id: 20,
        value: 20
    }, {
        id: 21,
        value: 21
    }, {
        id: 22,
        value: 22
    }, {
        id: 23,
        value: 23
    }, {
        id: 24,
        value: 24
    }, {
        id: 25,
        value: 25
    }, {
        id: 26,
        value: 26
    },  {
        id: 27,
        value: 27
    }, {
        id: 28,
        value: 28
    }, {
        id: 29,
        value: 29
    }, {
        id: 30,
        value: 30
    }, {
        id: 31,
        value: 31
    },
]

export const mounths = [
    {
        id:0,
        title: '-'
    },
    {
        id:1,
        title: 'Январь'
    },
    {
        id:2,
        title: 'Февраль'
    },
    {
        id:3,
        title: 'Март'
    },
    {
        id:4,
        title: 'Апрель'
    },
    {
        id:5,
        title: 'Май'
    },
    {
        id:6,
        title: 'Июнь'
    },
    {
        id:7,
        title: 'Июль'
    },
    {
        id:8,
        title: 'Август'
    },
    {
        id:9,
        title: 'Сентябрь'
    },
    {
        id:10,
        title: 'Октябрь'
    },
    {
        id:11,
        title: 'Ноябрь'
    },
    {
        id:12,
        title: 'Декабрь'
    },

]

export const years = [
    {
        id: 0,
        value: "-"
    },
    {
        id: 1,
        value: 1985
    },
    {
        id: 2,
        value: 1986
    },
    {
        id: 3,
        value: 1987
    },
    {
        id: 4,
        value: 1988
    },
    {
        id: 5,
        value: 1989
    },
    {
        id: 6,
        value: 1990
    },
    {
        id: 7,
        value: 1991
    },
    {
        id: 8,
        value: 1992
    },
    {
        id: 9,
        value: 1993
    },
    {
        id: 10,
        value: 1994
    },
    {
        id: 12,
        value:1996
    }, {
        id: 13,
        value: 1997
    },

    {
        id: 15,
        value: 1998
    },
    {
        id: 16,
        value: 1999
    },
    {
        id: 17,
        value: 2000
    }, {
        id: 18,
        value: 2001
    }, {
        id: 19,
        value: 2002
    }, {
        id: 20,
        value: 2003
    }, {
        id: 21,
        value: 2004
    }, {
        id: 22,
        value: 2005
    }, {
        id: 23,
        value: 2006
    }, {
        id: 24,
        value: 2007
    }, {
        id: 25,
        value: 2008
    }, {
        id: 26,
        value: 2009
    }, 
]